import styled from 'styled-components/macro';

export const Wrapper = styled.div`
  padding: 0 ${({ theme }) => theme.pad.xlg}% ${({ theme }) => theme.pad.xsm}%;
  height: fit-content;
`;
